import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';

const SKELETON_ITEM_COUNT = 8;

export const WhoIsLoading: React.FC = () => (
  <List disablePadding>
    {Array.from({ length: SKELETON_ITEM_COUNT }).map((_, index) => (
      // oxlint-disable-next-line react/no-array-index-key
      <Box key={index}>
        <ListItem disableGutters sx={{ py: 0.5, px: 0.5 }}>
          <ListItemAvatar sx={{ minWidth: 45 }}>
            <Skeleton variant="circular" width={35} height={35} />
          </ListItemAvatar>
          <ListItemText
            primary={<Skeleton variant="text" width="70%" height={18} />}
            secondary={<Skeleton variant="text" width="40%" height={12} />}
          />
        </ListItem>
        {index < SKELETON_ITEM_COUNT - 1 && <Divider sx={{ borderColor: '#f0f0f4' }} />}
      </Box>
    ))}
  </List>
);
